var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 91,
    viewBox: "0 0 70 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.91528,
    y: 1,
    width: 67,
    height: 89,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1727 13.1416L34.9747 12.2768L33.0252 12.7232L33.2915 13.8861L19.5215 79.294L21.4786 79.706L34.3563 18.5361L48.0252 78.2232L49.9747 77.7768L35.3391 13.868L35.4785 13.206L35.1727 13.1416Z",
    fill: "#7ABB5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0693 45.1975L59.5172 45.0706L59.2967 44.2927L59.4884 43.5302L59.0493 43.4198L58.9718 43.1464L58.4971 43.2809L13.7438 32.0302L13.2562 33.9698L54.6413 44.3739L11.7273 56.5379L12.2727 58.4621L58.528 45.351L59.0008 45.4698L59.0693 45.1975Z",
    fill: "#7ABB5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.19870ecfe3de8ae836b5b0b5fa65b09e.svg";
export { ForwardRef as ReactComponent };